import { Grid } from '@mui/material';
import NoGraphData from './NoGraphData';
import AgrochemicalsGroupBarGraph from './AgrochemicalsGroupBarGraph';
import AgrochemicalsGroupPieChart from './AgrochemicalsGroupPieChart';

export default function AgrochemicalsGraphPairForGroups({ barGraphData, pieChartData, companyName, year, type, unit }) {
    return (
        <NoGraphData data={barGraphData} year={year} type={type} variant={'agrochemicals'}>
            <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                <AgrochemicalsGroupBarGraph data={barGraphData} companyName={companyName} type={type} year={year} unit={unit} />
            </Grid>
            <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                <AgrochemicalsGroupPieChart data={pieChartData} companyName={companyName} type={type} year={year} unit={unit} />
            </Grid>
        </NoGraphData>
    )
}